exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".user-selects-wpr{position:relative}.user-selects-wpr .remove-btn{position:absolute;right:10px;top:13px;z-index:1;font-size:12px;color:#ddd;cursor:pointer}.user-selects-wpr .remove-btn:hover{color:#20a0ff}.user-selects{width:100%}.user-selects-list .user-name{float:left}.user-selects-list .user-dept{margin:1px 25px 0 10px;float:right;font-size:12px;color:#bbb}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3717537c","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/userSelect/searchDownList.vue
// module id = 784
// module chunks = 23